module.exports = __webpack_public_path__ + "img/ld-img-30@2x.4d4be60c.png";